import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { t } from '../../i18n';

/**
 * Generic placeholder for sections not yet implemented in Phase 0
 * (Students, Classes, Settings). Shows a heading and empty state.
 */
@customElement('cadence-placeholder-page')
export class CadencePlaceholderPage extends LitElement {
  /** i18n key for the heading, e.g. 'common.nav.students'. */
  @property() titleKey = '';
  /** Optional list of tab labels (used by the Settings shell). */
  @property({ type: Array }) tabs: string[] = [];

  static styles = css`
    :host { display: block; }
    h1 { margin: 0 0 var(--space-4); font-size: 1.6rem; }
    .tabs { display: flex; gap: 6px; margin-bottom: var(--space-5); flex-wrap: wrap; }
    .tab {
      padding: 8px 14px; border-radius: var(--radius-md);
      border: 1px solid var(--color-border); background: var(--color-bg-primary);
      color: var(--color-text-secondary); font-size: 0.88rem;
    }
    .tab:first-child { border-color: var(--color-primary); color: var(--color-primary); }
    .empty {
      background: var(--color-bg-primary); border: 1px dashed var(--color-border);
      border-radius: var(--radius-lg); padding: var(--space-6);
      text-align: center; color: var(--color-text-secondary);
    }
  `;

  render() {
    return html`
      <h1>${this.titleKey ? t(this.titleKey) : ''}</h1>
      ${this.tabs.length
        ? html`<div class="tabs">${this.tabs.map((tab) => html`<span class="tab">${tab}</span>`)}</div>`
        : ''}
      <div class="empty" data-section="empty-state">${t('common.states.empty')}</div>
    `;
  }
}
